module.exports = __webpack_public_path__ + "static/img/logo-top-20240129.55ef7b0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo-top-20240129.png
// module id = UrZU
// module chunks = 0